import { Component, inject, Input, OnInit } from '@angular/core';
import { downloadPdf } from '@app/helpers/webform';
import { TextsService } from '@app/services/texts.service';
import { WebformService } from '@app/services/webform.service';

@Component({
  standalone: false,
  selector: 'webform-pdfgenerate',
  templateUrl: './pdfgenerate.component.html',
  styleUrls: ['./pdfgenerate.component.scss'],
})
export class PdfgenerateComponent {
  @Input() id!: string;
  @Input() title!: string;
  @Input() value!: string;
  @Input() plugin!: string;

  readonly #webform = inject(WebformService);
  readonly #texts = inject(TextsService);

  async download(): Promise<void> {
    const document: string = await this.#webform.getApplication(this.plugin);
    const fileName: string = await this.#texts.getText(
      `application_download_${this.plugin}`,
      'primcalc',
      'antrag-standart.pdf'
    );
    downloadPdf(document, fileName || 'download');
  }
}
